import React, { useState } from 'react';
import { FaXTwitter, FaInstagram, FaFacebook, FaYoutube, FaReddit } from 'react-icons/fa6';
import InfoModal from '../Modals/InfoModal';
import './Footer.css';

const Footer = () => {
  const [showInfoModal, setShowInfoModal] = useState(null);

  return (
    <>
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-copyright">
            <span>© 2026 KRIME Inc. All rights reserved.</span>
          </div>

          <div className="footer-links">
            <button onClick={() => setShowInfoModal('disclaimer')}>Disclaimer</button>
            <span>|</span>
            <button onClick={() => setShowInfoModal('terms')}>Terms of Use</button>
            <span>|</span>
            <button onClick={() => setShowInfoModal('privacy')}>Privacy Policy</button>
            <span>|</span>
            <button onClick={() => setShowInfoModal('contact')}>Contact</button>
          </div>

          <div className="footer-social">
            <a href="https://x.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <FaXTwitter size={14} />
            </a>
            <a href="https://youtube.com/@krimeapp" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube size={14} />
            </a>
            <a href="https://instagram.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram size={14} />
            </a>
            <a href="https://facebook.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook size={14} />
            </a>
            <a href="https://reddit.com/r/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
              <FaReddit size={14} />
            </a>
          </div>
        </div>
      </footer>

      {showInfoModal && (
        <InfoModal
          type={showInfoModal}
          onClose={() => setShowInfoModal(null)}
        />
      )}
    </>
  );
};

export default Footer;
